var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initArticleCard = /* @__PURE__ */ __name(($el, $refs, articleHandle) => {
  var _a, _b;
  const random_id = utils.shortUUID();
  const article = _articles[articleHandle] || utils.JSONParse((_a = document.querySelector(`[data-article-data="${articleHandle}"]`)) == null ? void 0 : _a.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...article != null ? article : {},
    url: (_b = article == null ? void 0 : article.url) != null ? _b : `/blogs/${article == null ? void 0 : article.handle}`
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels
  };
}, "initArticleCard");
const fallbackHydrationQueue = /* @__PURE__ */ new Set();
const hydrateArticleCardContent = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c;
  const card_handle = $el.getAttribute(`data-card-handle`);
  const article_handle = $el.getAttribute(`data-article-handle`);
  const article_id = $el.getAttribute(`data-article-id`);
  const classes = utils.JSONParse((_a = $el.getAttribute(`data-card-classes`)) != null ? _a : "[]");
  const node = (_b = document.querySelector(`[data-article-card='${card_handle}']`)) == null ? void 0 : _b.cloneNode(true);
  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }
  node == null ? void 0 : node.removeAttribute(`data-article-card`);
  node == null ? void 0 : node.setAttribute("data-article-handle", article_handle);
  node == null ? void 0 : node.setAttribute("data-article-id", article_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });
  node.classList.add(...classes);
  (_c = $el.parentNode) == null ? void 0 : _c.replaceChild(node, $el);
}, "hydrateArticleCardContent");
document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateArticleCardContent(el);
  });
  fallbackHydrationQueue.clear();
});
const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateArticleCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);
const hydrateArticleCard = /* @__PURE__ */ __name(($el) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateArticleCardContent($el);
    return;
  }
  observer.observe($el);
}, "hydrateArticleCard");
window._sections["initArticleCard"] = initArticleCard;
window._sections["hydrateArticleCard"] = hydrateArticleCard;
